import React, { useContext, useState } from 'react';
import { UserContext } from '../../data/betslip/UserConf';
import { PvrContext } from '../../data/pvr/PvrConf';
import { getConfiguration, getCurrencyValue, getLocaleDotRound, getValidAmountString, getAmountInCent } from '../../data/utils';
import { getLabel } from '../../InitData';

function PvrSection(props) {
	const userContext = useContext(UserContext);
	const pvrContext = useContext(PvrContext);
	const user = userContext.getUser();
	const conf = getConfiguration();
	const mult = conf.cs.m;
	const nDec = conf.cs.nd;
	const curr = conf.cs.ct;
	const charDecimalBrowser = getLocaleDotRound().round;
	const [nicknameField, setNicknameField] = useState(''); // could be also "usercode" if this customer is enabled to do that
	const [passwordField, setPasswordField] = useState('');
	const pvrMessage = pvrContext.pvrSectionMessage;
	
	function testLoginUser(){
		if(nicknameField.length > 0 && passwordField.length > 0){
			pvrContext.testLoginUser(nicknameField, passwordField);
		}
		else{
			pvrContext.setPvrSectionMessage('error', 'Riempi tutti i campi!');
		}
	}
	
	let sectionClass = "widget-ultimi bg-bianco bordo-tondo margine-giu widget-betslip";
	if(pvrContext.ajaxInProgress){
		sectionClass = sectionClass + ' blurBetslip';
	}
	
	function handleEnterKey(event){
		if(event.key === "Enter"){
			testLoginUser();
		}
	}
	
	function testLogoutUser(){
		pvrContext.testLogoutUser();
	}
	function refreshBalance(){
		pvrContext.reloadUser();
	}
	
	const [depositAmount, setDepositAmount] = useState('');
	
	function typeDepositAmountHandler(settedAmount){
	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
	   settedAmount = getValidAmountString(settedAmount, nDec);
	   // putting the "browser decimal dot" instead of the "." for the float type
	   let fieldTextValue = settedAmount;
	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
	   
	   // if is number, I calculate the new amount and I keep it into the field value. 
	   // If not, I keep the field but I use the last valid amount for the calcs
	   if(isNaN(settedAmount) == false && settedAmount.length > 0){
		   pvrContext.setDepositAmountCent(getAmountInCent(parseFloat(settedAmount), mult));
	   }
	   setDepositAmount(fieldTextValue);
	}
	
	
	function testDeposit(){
		pvrContext.testDepositPvr(false, null);
	}
    return (
	<div className={sectionClass}>
	    <div className="titolo-widget-stampa maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx">
	    	<span className="maiuscolo"><i className="fas fa-circle"></i> {getLabel('pvr.widget_title')} </span>
	    </div>
	    <div className="contenuto-widget-ultime-v bordato-widget">
	    	{
	    		user.logged  && <>
					<div className="pvrUserContainer"> 
	    				<div> {getLabel('pvr.welcome')} <span className="grassetto"> {user.nickname} </span> </div>
	    				<button onClick={() => {testLogoutUser()}} className="bottone bg-blu bianco"> {getLabel('pvr.logout')} </button> 
					</div>
					<div className="pvrUserBalanceRow"> 
						<div className="balanceValue"> Saldo <span className="grassetto"> {getCurrencyValue(user.balance, mult, nDec, curr)} </span> </div>
                        <div onClick={() => {refreshBalance()}} className="refreshButton">
                        <i className="fa fa-sync"></i>
                    </div>
					</div>
					{
						pvrContext.testDepositUserEnabled && (
			    			<div className="pvrTestDepositRow">
								<input onChange={e => {pvrContext.deletePvrSectionMessage(); typeDepositAmountHandler(e.target.value);}} 
									   type='text' 
									   autoComplete="off" 
									   value={depositAmount}
									   placeholder={getLabel('pvr.deposit_amount')}  />
								<button onClick={() => {testDeposit()}} className="bottone bg-rosso bianco"> {getLabel('pvr.deposit')} </button> 
							</div>
						)
					}

				</>
	    	}
	    
	    	{
	    		user.logged == false && pvrContext.testLoginUserEnabled && (
    				<div className="pvrUserFormContainer"> 
	    				<input onChange={(e) => { pvrContext.deletePvrSectionMessage(); setNicknameField(e.target.value);}} type='text' autoComplete="off" placeholder={getLabel('pvr.username')} value={nicknameField} />
	    				<input onKeyUp={(e) => {handleEnterKey(e)}} onChange={(e) => { pvrContext.deletePvrSectionMessage(); setPasswordField(e.target.value);}} type='password' autoComplete="off" placeholder={getLabel('pvr.password')} value={passwordField} />
	    				<button onClick={() => {testLoginUser()}} className="bottone bg-blu bianco">{getLabel('pvr.login')}</button> 
    				</div>
	    		
	    		)
	    	}
	    	{
	    		pvrMessage != null &&(
    				<div className="pvrMessageContainer">
	        		    <div className={"betslip-message " + pvrMessage.type}>
	    	    			<div> {pvrMessage.message} </div>
	    	    		</div>
    				</div>
	    		)
	    	}
	    
	    </div>
	
	</div>
    )
}

export default PvrSection;